import { Routes } from '@angular/router';
import { CoverInfoComponent } from '../components/cover-info/cover-info.component';
import { CoverInfoSettings } from '../components/cover-info/CoverInfoSettings';
import { IndexComponent } from './components/index/index.component';

export const mopedRoutes: Routes = [
    { path: '', component: IndexComponent },
    { path: 'ansvarsforsikring', component: CoverInfoComponent, data: new CoverInfoSettings('moped', 'liability', 'nf nf-moped-icon-v3') },
];
